import { useTranslation } from "react-i18next";
import { FormatId, FORMATS } from "../constants/formats";
import { Trans } from "react-i18next";
import { Button } from "./Button";
import styles from "./DeluxeModal.module.css";
import { Modal } from "./Modal";

const DELUXE_OPTIONS: { format: FormatId; price: number; url: string }[] = [
  {
    format: "SMALL",
    price: 138.0,
    url:
      "https://kinderkiez.net/products/kinderkiez-spielteppich-deluxe-s-70x100cm?utm_source=universe&utm_medium=app",
  },
  {
    format: "ROUND_MEDIUM",
    price: 218.0,
    url:
      "https://kinderkiez.net/products/kinderkiez-spielteppich-deluxe-m-rund-100cm-o?utm_source=universe&utm_medium=app",
  },
  {
    format: "MEDIUM",
    price: 218.0,
    url:
      "https://kinderkiez.net/products/kinderkiez-spielteppich-deluxe-m-140x100cm?utm_source=universe&utm_medium=app",
  },
  {
    format: "ROUND_LARGE",
    price: 348.0,
    url:
      "https://kinderkiez.net/products/kinderkiez-spielteppich-deluxe-l-rund-140cm-o-2?utm_source=universe&utm_medium=app",
  },
  {
    format: "LARGE",
    price: 348.0,
    url:
      "https://kinderkiez.net/products/kinderkiez-spielteppich-deluxe-l-200x140cm?utm_source=universe&utm_medium=app",
  },
];

const formatter = Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

export const DeluxeModal = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("deluxe-modal_title")}
      show={show}
      large
      actions={
        <Button secondary expanded onClick={onClose}>
          {t("deluxe-modal_cancel")}
        </Button>
      }
    >
      <p className={styles.text}>
        <Trans i18nKey="deluxe-modal_description" />
      </p>
      <div className={styles.grid}>
        {DELUXE_OPTIONS.map(({ format, url, price }) => {
          const formatConfig = FORMATS[format];
          return (
            <a href={url} className={styles.column} key={url}>
              <div className={styles.imageContainer}>
                <img
                  className={styles.image}
                  src={`/images/format-${format.toLowerCase()}.png`}
                  alt={t(`size_title--${format.toLowerCase()}`)}
                  width={formatConfig.displayWidth / 2}
                />
              </div>

              <strong>{t(`deluxe-modal_${format.toLowerCase()}_title`)}</strong>
              <div>
                {formatConfig.round
                  ? `${formatConfig.displayWidth}cm ⌀`
                  : `${formatConfig.displayWidth}x${formatConfig.displayHeight}cm`}
              </div>
              <div className={styles.price}>{formatter.format(price)}</div>
              <Button
                round
                expanded
                size="tiny"
                onClick={() => (window.location.href = url)}
              >
                {t("deluxe-modal_buy")}
              </Button>
            </a>
          );
        })}
      </div>
      <p className={styles.text}>
        <Trans i18nKey="deluxe-modal_how-it-works" />
      </p>
    </Modal>
  );
};
